module.exports = __webpack_public_path__ + "static/media/headerLogo.970686b8.png";